// src/StartPage.js
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import './StartPage.css' // Import the CSS file
import { getEnv } from '../config/env'

const StartPage = () => {
  const navigate = useNavigate()
  const [index, setDepartment] = useState('')
  const [query, setQuery] = useState('')
  const [id, setId] = useState('')
  const [messages, setMessages] = useState([]) // Store chat messages
  const [userId, setUserId] = useState('')
  const [userMail, setUserMail] = useState('')
  const [showMessage, setShowMessage] = useState(false)
  const [textColor, setTextColor] = useState('#000000')
  const [selectedFont, setSelectedFont] = useState('Arial, sans-serif')
  const [translate, setTranslate] = useState(false)
  const [showSystemMessage, setShowSystemMessage] = useState(true)
  const [showSearchContextOptions, setShowSearchContextOptions] = useState(true)
  const [errorT, setError] = useState('...')

  useEffect(() => {
    document.title = 'Stratsys AI'

    heartbeat()
  }, [])

  const heartbeat = async () => {
    try {
      console.log('Current loc...')
      console.log(window.location.host)
      console.log('Fetching heartbeat from ...')
      console.log(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/heartbeat`)

      const response = await window.PDR.api.get(
        `${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/heartbeat`
      ) /**await axios.get(`${getEnv('REACT_APP_AI_API_BACKEND_BASE_URL')}/heartbeat`)**/
      setUserId(response.user)
      setUserMail(response.user)
      setError('')
    } catch (error) {
      console.log('Error fetching data:', error)
    }
  }

  const handleDepartmentChange = (event) => {
    setDepartment(event.target.value)

    if (event.target.value === 'Support') {
      setShowSystemMessage(true)
      setShowSearchContextOptions(false)
    }
  }

  // const getUserInfo = async () => {
  //   try {
  //     const response = await fetch('/.auth/me')
  //     const payload = await response.json()
  //     console.log('User information: ', payload)
  //     const { clientPrincipal } = payload
  //     setUserId(clientPrincipal.userId)
  //     setUserMail(clientPrincipal.userDetails)
  //   } catch (error) {
  //     if (window.location.host !== 'localhost:8080') {
  //       setError('ERROR: Issue with fetching user information. Please refresh the page.')
  //     } else {
  //       setUserId('anonymous')
  //       setUserMail('anonymous')
  //     }
  //     console.log('Error fetching user information: ', error)
  //   }
  // }

  // }
  // catch (error) {
  //   console.error('Error fetching data:', error)
  // }

  // useEffect(() => {
  //   getUserInfo()
  // }, [])

  const handleGotoDashboards = () => {
    navigate('/dashboardpage', { state: { userId, userMail } })
  }

  const handleSearch = () => {
    // Navigate to the result page with the query parameter
    if (!index) {
      // Set showMessage to true if no department is selected
      setShowMessage(true)
    } else {
      setShowMessage(false) // Reset the showMessage state
      console.log('Navigating to results page')
      console.log(showSearchContextOptions)
      navigate(`/results`, {
        state: { query, id, index, messages, userId, userMail, showSystemMessage, showSearchContextOptions }
      })
    }
  }

  function Card({ title, content }) {
    return (
      <div className="card">
        <h3 className="card-title">{title}</h3>
        <p className="card-content">{content}</p>
      </div>
    )
  }

  const options = [
    { value: 'Support', text: 'Support' },
    { value: 'People', text: 'People' },
    { value: 'Basic', text: 'StratGPT' }
  ]

  const options2 = [
    { value: 'Support', text: 'Support' },
    { value: 'Basic', text: 'StratGPT' }
  ]
  const optionsToUse = options //window.location.host === 'bot.stratsys.net' ? options : options2

  return (
    <div>
      <img
        className="stratsys-icon"
        src="https://frontend-packages.svc.stratsys.com/logos/icon-dark.svg"
        alt="Stratsys Icon"
      />
      <div className="start-header-container">
        <one-ux-text class="start-header">Welcome to Stratsys AI!</one-ux-text>
      </div>

      <div className="start-subheader-container">
        <one-ux-text class="start-subheader">Select a department to start your conversation:</one-ux-text>
      </div>
      <div className="start-radio-container">
        <one-ux-radio-group
          class="radio-group"
          options={optionsToUse}
          radio-position="before-text"
          label="Please choose one"
          required
          columns={optionsToUse.length}
          compact
          implicit
          onChange={handleDepartmentChange}></one-ux-radio-group>
      </div>

      <div className="ellipse-container">
        <div className="ellipse-big"></div>
        <div className="ellipse-small"></div>
        <div className="ellipse-faded"></div>
      </div>

      <div
        className="go-button-container"
        style={{
          pointerEvents: !errorT ? 'auto' : 'none',
          opacity: errorT ? 0.2 : 1
        }}>
        {showMessage && <p className="department-message">Please select an option</p>}
        <one-ux-button
          class="start-button"
          label="Start"
          purpose="main"
          weight="normal"
          state="default"
          onClick={handleSearch}>
          <one-ux-icon icon="ai-powered" slot="start" set="ai"></one-ux-icon>
        </one-ux-button>
      </div>

      <div className="card-container">
        <div className="card">
          <one-ux-icon class="card-icon" icon="comment" slot="start" set="default"></one-ux-icon>
          <one-ux-text class="card-title">Ask Away</one-ux-text>
          <one-ux-text class="card-content">
            Stratsys AI can answer questions, help you learn, brainstorm and much more. Stratsys AI will access
            different documents depending on your selected department.
          </one-ux-text>
        </div>
        <div className="card">
          <one-ux-icon class="card-icon" icon="preview" slot="start" set="forms"></one-ux-icon>
          <one-ux-text class="card-title">Don't share sensitive info</one-ux-text>
          <one-ux-text class="card-content">
            Chat history may be reviewed or used to improve the AI model in future iterations.
          </one-ux-text>
        </div>
        <div className="card">
          <one-ux-icon class="card-icon" icon="user-confidential" slot="start" set="user-permission"></one-ux-icon>
          <one-ux-text class="card-title">Check you facts</one-ux-text>
          <one-ux-text class="card-content">
            While we have safeguards, Stratsys AI may give inaccurate information. It's not intended to give advice.
          </one-ux-text>
        </div>
      </div>
      <div className="auth-container">
        {/* <p className='user-info-start'>Authenticated as: {userInfo.userDetails}</p> */}
        <one-ux-text class="auth-info">Authenticated as: {userMail}</one-ux-text>
      </div>
      {userId ? (
        <div className="auth-container" style={{ cursor: 'pointer' }} onClick={handleGotoDashboards}>
          <one-ux-text class="auth-info">Are you looking for your dashboard? Find it here!</one-ux-text>
        </div>
      ) : (
        <div className="auth-container">
          <one-ux-text class="auth-info">The AI team wishes you an awesome day!</one-ux-text>
        </div>
      )}

      <div>{errorT && <p className="ErrorText">{errorT}</p>}</div>
    </div>
  )
}

export default StartPage
